import { IActivePass, IPassGroup } from '../../models'

export enum BuyPassPhase {
  IDLE = 'IDLE',
  CREATING = 'CREATING',
  CONFIRMING = 'CONFIRMING',
  POLLING = 'POLLING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

export interface IWalletState {
  activePasses: IActivePass[]
  isFetchingActivePasses: boolean
  availablePasses: IPassGroup[]
  isFetchingAvailablePasses: boolean
  buyPassPhase: BuyPassPhase
}
